import React from "react";
import { twMerge } from "tailwind-merge";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value?: string;
  width?: React.CSSProperties["width"];
  error?: string;
  className?: string;
  onValueChange?: (newValue: string) => void;
}

export default function Input({
  value,
  width,
  onValueChange,
  className,
  ...rest
}: InputProps) {
  const onStringChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onValueChange) {
      const { value } = event.target;
      onValueChange(value);
    }
  };

  const isFileInput = rest.type === "file";

  return (
    <div
      className={twMerge(
        "relative flex h-[50px] max-h-full w-full items-center rounded-md border border-zinc-300 bg-white px-3 py-1 transition-colors duration-300 focus-within:border-black disabled:bg-zinc-50 disabled:text-zinc-500",
        rest.disabled && "bg-zinc-100",
        className
      )}
    >
      <input
        className={twMerge(
          "flex h-full w-full items-center outline-none",
          isFileInput && "py-1",
          "[&::-webkit-calendar-picker-indicator]:absolute",
          "[&::-webkit-calendar-picker-indicator]:right-2",
          "[&::-webkit-calendar-picker-indicator]:cursor-pointer"
        )}
        value={value}
        onChange={(event) => {
          if (!!rest.onChange) {
            rest.onChange(event);
          } else {
            onStringChange(event);
          }
        }}
        {...rest}
      />
    </div>
  );
}
